import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllSocieties(_obj, params) {
    const res = await axios.get(`api/universities/societies-admin/`, { params });
    return res.data;
  },
  async getSociety(_obj, id) {
    const res = await axios.get(`api/universities/societies-admin/${id}/`);
    return res.data;
  },
  async createSociety(_obj, data) {
    return axios.post(`api/universities/societies-admin/`, data);
  },
  async updateSociety(_obj, { id, data }) {
    return axios.patch(`api/universities/societies-admin/${id}/`, data);
  },
  async deleteSociety(_obj, id) {
    return axios.delete(`api/universities/societies-admin/${id}/`);
  },
};

export const societies = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
